document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const footer = document.querySelector('.footer');
    const content = document.querySelector('.knowledge-content');
    const items = document.querySelectorAll('.glossary-item');
    const panes = document.querySelectorAll('.glossary-pane');
    const collapses = document.querySelectorAll('.glossary-collapse');

    const removeClass = (list) => {
        list.forEach(item => {
            if (item.matches('.is-active')) item.classList.remove('is-active');
        });
    };

    const mobileState = () => {
        collapses.forEach((collapse, i) => {
            let head = collapse.children[0];
            let body = collapse.children[1];

            // init the first collapse
            if (!i) {
                collapse.classList.add('is-active');
                body.style.maxHeight = body.scrollHeight + 'px';
            }

            // toggle each collapse
            head.addEventListener('click', () => {
                collapse.classList.toggle('is-active');
                body.style.maxHeight = collapse.classList.contains('is-active') ? body.scrollHeight + 'px' : null;
            });
        });
    };

    const desktopState = () => {
        // scroll to pane's top by click
        items.forEach(item => {
            const id = item.dataset.paneId;
            const pane = document.querySelector(id);

            item.addEventListener('click', () => {
                const gap = 10; // gap between header & pane
                const paneTop = pane.offsetTop - header.offsetHeight - gap;

                window.scrollTo({
                    top: paneTop,
                    behavior: 'smooth'
                });

                // Edge solution
                if (navigator.userAgent.includes('Edge')) {
                    $('html, body').animate({ scrollTop: paneTop }, 500);
                }
            });
        });

        // scroll spy
        ['DOMContentLoaded', 'scroll'].forEach(evt => {
            document.addEventListener(evt, () => {
                const list = document.querySelector('.glossary-list');
                const subtitle = document.querySelector('.knowledge-section_desktop .glossary-heading');

                // fixed sidebar
                const subtitleCoords = subtitle.getBoundingClientRect();

                (subtitleCoords.top - header.offsetHeight < 0)
                    ? list.classList.add('is-fixed')
                    : list.classList.remove('is-fixed');


                // attach sidebar to bottom
                const contentCoords = content.getBoundingClientRect();
                const footerCoords = footer.getBoundingClientRect();
                const contentGap = footerCoords.top - contentCoords.bottom;
                const listOffsetBottom = list.offsetHeight + header.offsetHeight + contentGap;

                (contentCoords.bottom - listOffsetBottom < 0)
                    ? list.classList.add('is-fixed-bottom')
                    : list.classList.remove('is-fixed-bottom');


                panes.forEach((pane, i) => {
                    const gap = 11; // the gap between collapses
                    const paneCoords = pane.getBoundingClientRect();
                    const paneStart = header.offsetHeight + gap;
                    const paneEnd = header.offsetHeight - gap;
                    const item = document.querySelector('[data-pane-id="#' + pane.id + '"]');

                    if (!i && (paneCoords.top > paneStart)) {
                        removeClass(items);
                        removeClass(panes);
                    }

                    if (paneCoords.top <= paneStart && paneCoords.bottom >= paneEnd) {
                        removeClass(items);
                        removeClass(panes);
                        item.classList.add('is-active');
                        pane.classList.add('is-active');
                    }
                });
            });
        })
    };


    collapses && mobileState();
    items && panes && desktopState();
});
